import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Buildings, IconProps } from 'phosphor-react';
import { UI } from '../ui';

interface EmptyStateProps {
  title: string;
  message: string;
  icon?: React.ComponentType<IconProps>;
}

export function EmptyState({ title, message, icon: IconCmp = Buildings }: EmptyStateProps) {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      textAlign="center"
      py={16}
      px={6}
      bg={UI.glass}
      border="1px solid"
      borderColor={UI.glassBorder}
      borderRadius="16px"
      backdropFilter={UI.glassBlur}
      boxShadow={UI.glassShadow}
    >
      <Flex
        align="center"
        justify="center"
        w="52px"
        h="52px"
        borderRadius="14px"
        bg={UI.infoSoft}
        color={UI.brand}
        mb={4}
      >
        <IconCmp size={26} />
      </Flex>
      <Text fontSize="15px" fontWeight={700} color={UI.ink} mb={1.5}>
        {title}
      </Text>
      <Text fontSize="13px" color={UI.muted} maxW="320px">
        {message}
      </Text>
    </Flex>
  );
}
